import React from 'react';

import { Box, Grid, Typography } from '@blueprint/ui';
import { useTranslation } from 'react-i18next';

import DefaultTable from '../Table/DefaultTable';

const MultipleSelection = ({
    tableData,
    columns,
    payoutAmount,
    payoutCurrency,
    showPaypalEmail,
    paypalEmail,
    showAddress,
    paymentAddress,
    showBankDetails,
    bankDisplayValue,
    coolingOffPeriod,
    showFxRate,
    fxRate,
    showTotalPayerAmount,
    totalPayerAmount,
    payerCurrency,
}) => {
    const { t } = useTranslation();

    return (
        <Grid container component='dl'>
            <Box marginTop={['20px', '20px', '20px', '24px']} width='100%'>
                <DefaultTable data={tableData} columns={columns} />
            </Box>

            {showTotalPayerAmount ? (
                <Grid container>
                    <Grid item xs={6} sm={2} component='dt'>
                        <Box marginTop={2}>
                            <Typography variant='body1'>{t('verifyDetailsConfirm.totalPayerAmount')}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6} component='dd'>
                        <Box marginTop={2} marginLeft='20px'>
                            <Typography variant='body1'>
                                {payerCurrency} &nbsp;{totalPayerAmount}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            ) : null}

            <Grid container>
                <Grid item xs={6} sm={2} component='dt'>
                    <Box marginTop={2}>
                        <Typography variant='body1'>{t('verifyDetailsConfirm.totalPayoutAmount')}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={6} component='dd'>
                    <Box marginTop={2} marginLeft='20px'>
                        <Typography variant='body1'>
                            {payoutCurrency} &nbsp;{payoutAmount}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
            {showFxRate ? (
                <Grid container>
                    <Grid item xs={6} sm={2} component='dt'>
                        <Box marginTop={2}>
                            <Typography variant='body1'>{t('verifyDetailsConfirm.rate_used')}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6} component='dd'>
                        <Box marginTop={2} marginLeft='20px'>
                            <Typography variant='body1' id='verify-typo-rateused'>
                                {fxRate}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            ) : null}
            {showBankDetails ? (
                <Grid container>
                    <Grid item xs={6} sm={2} component='dt'>
                        <Box marginTop={2}>
                            <Typography variant='body1'>{t('verifyDetailsConfirm.yourBankAccDetails')}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6} component='dd'>
                        <Box marginTop={2} marginLeft='20px'>
                            <Typography variant='body1' id='verify-typo-bankDetails'>
                                {bankDisplayValue}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            ) : null}

            {showPaypalEmail ? (
                <Grid container>
                    <Grid item xs={6} sm={2} component='dt'>
                        <Box marginTop={2}>
                            <Typography variant='body1'>{t('verifyDetailsConfirm.yourEmailId')}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6} component='dd'>
                        <Box marginTop={2} marginLeft='20px'>
                            <Typography variant='body1'>{paypalEmail}</Typography>
                        </Box>
                    </Grid>
                </Grid>
            ) : null}
            {showAddress ? (
                <Grid container>
                    <Grid item xs={6} sm={2} component='dt'>
                        <Box marginTop={2}>
                            <Typography variant='body1'>{t('verifyDetailsConfirm.yourAddress')}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6} component='dd'>
                        <Box marginTop={2} marginLeft='20px'>
                            <Typography variant='body1' id='verify-typo-bankDetails'>
                                {paymentAddress}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            ) : null}
        </Grid>
    );
};

export default MultipleSelection;
